import { useEffect, useRef } from "react";

/**
 * Lightweight scroll-triggered background video.
 * - Streams only metadata until it nears the viewport (preload="metadata")
 * - Plays when >=20% visible, pauses when scrolled away (saves data + battery)
 * - Muted + playsInline so mobile autoplay always works
 */
export const MountainVideo = ({ className = "", testid }) => {
  const ref = useRef(null);

  useEffect(() => {
    const v = ref.current;
    if (!v) return;
    let visible = false;
    const tryPlay = () => {
      if (visible) v.play().catch(() => {});
    };
    const io = new IntersectionObserver(
      ([entry]) => {
        visible = entry.isIntersecting;
        if (visible) {
          v.preload = "auto"; // ab full stream start karo
          tryPlay();
        } else {
          v.pause();
        }
      },
      { threshold: 0.2 }
    );
    io.observe(v);
    // agar pehli play() call data na hone ki wajah se reject ho jaaye, canplay par retry
    v.addEventListener("canplay", tryPlay);
    return () => {
      io.disconnect();
      v.removeEventListener("canplay", tryPlay);
    };
  }, []);

  return (
    <video
      ref={ref}
      className={className}
      poster="/assets/mountain-poster.jpg"
      muted
      loop
      playsInline
      preload="metadata"
      disablePictureInPicture
      aria-label="Cinematic aerial drone footage at golden hour"
      data-testid={testid}
    >
      <source src="/assets/mountain-web.webm" type="video/webm" />
      <source src="/assets/mountain-web.mp4" type="video/mp4" />
    </video>
  );
};
